import { makeStyles } from "@material-ui/core/styles";

const modal = makeStyles({
  root: {
    position: "absolute",
    marginBottom: "16px",
    backgroundColor: "#FFF",
    width: "100%",
    borderRadius: "10px",
    maxWidth: (props) => (props.maxWidth ? props.maxWidth : "474px"),
  },
  title: {
    display: "flex",
    justifyContent: "space-between",
    height: "68px",
    alignItems: "center",
    borderBottom: "1px solid #E7E7ED",
    "& h1": {
      fontWeight: 600,
      fontSize: "1.28rem",
      color: "#272833",
      margin: "0 0 0 24px",
      padding: "0",
    },
  },
  body: {
    marginLeft: "24px",
    minHeight: "325px",
  },
  modalDelete: {
    height: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    "& h1": {
      color: "#272833",
    },
  },
  span: {
    marginTop: "12px",
    color: "#686868",
    fontWeight: "normal",
    display: 'block'
  },
  footer: {
    marginTop: "20px",
    minHeight: "83px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    borderRadius: " 0px 0px 10px 10px;",
    backgroundColor: "#F7F8F9",
  },
  footerModalDelete: {
    marginTop: "20px",
    minHeight: "83px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: " 0px 0px 10px 10px;",
    backgroundColor: "#F7F8F9",
  },
});

export { modal };
